import React, { useState } from "react";
import { connect } from "react-redux";
import Maincontent from "./Maincontent";
import GlobalLeaveList from "./GlobalLeave/GlobalLeaveList"; 

import { Layout, Breadcrumb, Tabs } from "antd";
const { Content } = Layout;
const { TabPane } = Tabs;

const LeaveType = () => {
  const [activeKey, setActiveKey] = useState("1");

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Leave</Breadcrumb.Item>
        <Breadcrumb.Item>{activeKey === "1" ? "LeaveType" : "Global Leave"}</Breadcrumb.Item>
      </Breadcrumb>

      <Content
        style={{
          padding: 24,
          margin: 0,
          minHeight: 280,
          background: "#fff",
        }}
      >
        <Tabs activeKey={activeKey} onChange={setActiveKey}>
          <TabPane tab="Leave Type" key="1">
            <Maincontent />
          </TabPane>
          <TabPane tab="Global Leave" key="2">
            <GlobalLeaveList />
          </TabPane>
        </Tabs>
      </Content>
    </>
  );
};

export default connect()(LeaveType);
